import type { BlockInfoWithIconAndBackground } from 'types/block-info-with-icon-and-background';
import React from 'react';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import Figure from './figure';

const InfoWithIconAndBackground: React.FC<BlockInfoWithIconAndBackground> = ({
  sectionId,
  icon,
  content,
}) => {
  return (
    <section id={sectionId} className="my-12 md:my-16 bg-purple-gradient">
      <Wrap className="lg:grid-cols-2-auto justify-items-center items-center gap-x-20">
        {icon && <Figure {...icon} />}
        {content?.length > 0 && (
          <HeadingBody
            title={content}
            level="4"
            tagName="h4"
            className="font-semibold text-white"
          />
        )}
      </Wrap>
    </section>
  );
};

export default InfoWithIconAndBackground;
